import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionState } from './session.reducer';
import { DEFAULT_INITIAL_URL, INTRANET_REQUESTED_URL_LABEL } from './session';

export enum CambioClaveMotivoErrorEnum {
	DECRYPT_ERROR,
	REQUISITO_ERROR,
	MF_CLAVE_ACTUAL_ERROR,
	MF_CAMBIO_CLAVE_ERROR,
	SIS_EXT_CAMBIO_CLAVE_ERROR,
	UNEXPECTED_ERROR
};

export const CENTRAL_SEDE_TYPE: string = "central";
export const SAN_JUSTO_SEDE_TYPE: string = "san-justo";

export const sessionState = createFeatureSelector<SessionState>("session");

export const idPersonaInstitucional = createSelector(
	sessionState,
	state => state.otherSystemData? state.otherSystemData.idPersonaInstitucional: null
);

export const idPersona = createSelector(
	sessionState,
	state => state.otherSystemData? state.otherSystemData.idPersona: null
)

export const useTokenAcceso = createSelector(
	sessionState,
	state => state.useTokenAcceso
);

export const sessionCreate = createSelector(
	sessionState,
	state => state.tokenSesion != null
);

export const sessionOnCreate = createSelector(
	sessionState,
	state => state.onCreate
)

export const sessionOpen = createSelector(
	sessionState,
	state => state.open
);

export const sessionOnInit = createSelector(
	sessionState,
	state => state.onInit
);

export const tokenSesion = createSelector(
	sessionState,
	state => state.tokenSesion
);

export const sessionUsuario = createSelector(
	sessionState,
	state => state.usuario
);

export const sessionIsUsuarioExterno = createSelector(
	sessionState,
	state => state.usuario? state.usuario.isExterno: null
)

export const sessionUsuarioExpiracionClave = createSelector(
	sessionState,
	state => state.usuario? state.usuario.expiracionClave: null
)

export const sessionPostponePassExpirationReady = createSelector(
	sessionState,
	state => state.postponePassExpirationReady
)

export const sessionValid = createSelector(
	sessionState,
	state => state.valid
);

const protocolDomainSep: string = '//';
const domainPathSep: string = '/';

export const sessionInitialUrl = createSelector(
	() => {
		let initialUrl: string = DEFAULT_INITIAL_URL;
		let requestedUrl: string = localStorage.getItem( INTRANET_REQUESTED_URL_LABEL );
		if( requestedUrl ) {
			// Obtengo de requestedURL el path y los parámetros
			let protocolDomainSepIndex: number = requestedUrl.indexOf( protocolDomainSep );
			if( protocolDomainSepIndex > 0 ) {
				let domainPathSepIndex: number = requestedUrl.indexOf( domainPathSep, protocolDomainSepIndex + protocolDomainSep.length );
				if( domainPathSepIndex > 0 )
					initialUrl = requestedUrl.substring( domainPathSepIndex );
			}
		}
		return initialUrl;
	}
)

export const idUsuario = createSelector(
	sessionState,
	state => state.otherSystemData? state.otherSystemData.idUsuario: null
)

export const otherSystemData = createSelector (
	sessionState,
	state => state.otherSystemData
)

export const pass = createSelector (
	sessionState,
	state => {
		let ce: string;
		let pass = '';
		try {
		 	ce = atob( state.otherSystemData.ce );
			for( let i = 0; i < ce.length; ++i ) {
				if( i % 2 == 0 )
					pass = pass + ce.substr( i, 1 );
			}
		} catch( Exception ) {
			// Ocurrió una excepción en atob!
			pass = null;
		}
		return pass;
	}
)

export const sessionConnectionType = createSelector(
	sessionState,
	state => state.connectionType
)

export const sessionSedeType = createSelector(
	sessionState,
	state => state.sedeType
)

export const sessionValidDate = createSelector(
	sessionState,
	state => state.validDate
)

export const sessionCambioClaveReady = createSelector(
	sessionState,
	state => state.cambioClaveReady
)

export const sessionCambioClaveMotivoError = createSelector(
	sessionState,
	state => state.cambioClaveMotivoError
)
